import useCurrentCompany from './useCurrentCompany';

const useFlipper = (flipper) => {
  const company = useCurrentCompany();

  if (company && company.flippers) {
    return company.flippers[flipper];
  }

  // Return a default value when company or company.flippers is undefined
  return null;
};

export default useFlipper;
